import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SearchState {
  query: string;
  isActive: boolean;
}

interface SearchStore extends SearchState {
  // Actions
  setQuery: (query: string) => void;
  setActive: (isActive: boolean) => void;
  clearSearch: () => void;

  // Utility
  getState: () => SearchState;
}

const defaultState: SearchState = {
  query: '',
  isActive: false,
};

export const useSearchStore = create<SearchStore>()(
  persist(
    (set, get) => ({
      // Initial state
      ...defaultState,

      // Actions
      setQuery: query => set({ query, isActive: query.trim().length > 0 }),
      setActive: isActive => set({ isActive }),
      clearSearch: () => set(defaultState),

      // Utility
      getState: () => {
        const state = get();
        return {
          query: state.query,
          isActive: state.isActive,
        };
      },
    }),
    {
      name: 'search-store',
      partialize: state => ({
        query: state.query,
        isActive: state.isActive,
      }),
    }
  )
);
